import { memo } from "react";

import { TemplatePage } from "../../2_ksbHub/0_TemplatePage/TemplatePage";
import { useAppContext } from "../../2_ksbHub/context/appContext";

import useAskomaState from "./hooks/useAskomaState";
import AskomaBody from "./components/AskomaBody";
import { AskomaContext } from "./context/AskomaContext";

/**
 * =========================================================
 * ✅ ASKOMA PAGE
 * =========================================================
 */
function AskomaPage() {
  const { currentUser, isAnAdmin, askomaLoading } = useAppContext();

  /**
   * =========================================================
   * ✅ STATE
   * =========================================================
   */
  const askomaState = useAskomaState();

  /**
   * =========================================================
   * ✅ PERMISSIONS
   * =========================================================
   */
  const isAskomaAdmin = isAnAdmin && currentUser?.id === 205;

  /**
   * =========================================================
   * ✅ RENDER
   * =========================================================
   */
  return (
    <AskomaContext.Provider
      value={{
        ...askomaState,
        currentUser,
        isAskomaAdmin,
        askomaLoading,
      }}
    >
      <TemplatePage type="askoma">
        <AskomaBody />
      </TemplatePage>
    </AskomaContext.Provider>
  );
}

export default memo(AskomaPage);
